import {
  pipe,
  prop,
  head,
  propEq,
  applySpec,
  always,
  propOr,
  pickBy,
  complement,
  isNil
} from 'ramda'

const MOSAIC_OPT_IN_ACTION_TYPE = 'MOSAIC_OPT_IN'
const MOSAIC_OPT_IN_DISPLAY_TYPE = 'Add to mosaic'

const isMosaicOptInWidgetAction = propEq('type', MOSAIC_OPT_IN_ACTION_TYPE)

const getMessage = pipe(prop('actions'), head, propOr(null, 'message'))
const getAttachmentUrl = pipe(
  prop('actions'),
  head,
  propOr(null, 'attachmentUrl')
)
const getCardUri = pipe(prop('actions'), head, propOr(null, 'cardUri'))
const getMedia = pipe(prop('actions'), head, propOr(null, 'media'))

const convertMosaicOptInWidgetActionToFormAction = pipe(
  applySpec({
    type: always(MOSAIC_OPT_IN_DISPLAY_TYPE),
    message: getMessage,
    attachmentUrl: getAttachmentUrl,
    cardUri: getCardUri,
    media: getMedia
  }),
  pickBy(complement(isNil))
)

export { isMosaicOptInWidgetAction, convertMosaicOptInWidgetActionToFormAction }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/twitter/widget-to-form/mosaic-opt-in.js